export default "__VITE_ASSET__a52c08c5__"